






















































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import FormNavigationButtons from '../common/FormNavigationButtons.vue';
import moment from 'moment';
import stringIsUndefined from '../utils/stringIsUndefined';
import { Prop, Watch } from 'vue-property-decorator';
import { setLongFormatDate } from '@/modules/shared/shared/domain/functions/date-functions';
import * as FORM_INTERFACE from '../interfaces/accessTicket.interface';
import * as rules from '@/modules/shared/shared/domain/rules';

@Component({
    components: {
        FormNavigationButtons,
    },
})
export default class StepGeneralInformation extends Vue {
    //only for TicketsModifyAccess
    @Prop()
    oldGeneralInformation!: FORM_INTERFACE.generalInformationInterface;

    @Prop({ default: {} })
    formValues!: {
        dataCenters: {
            value: number;
            text: string;
        }[];
        reasons: {
            value: number;
            text: string;
            motives: {
                value: number;
                text: string;
                reasonMotiveId: number;
            }[];
        }[];
    };
    isFormValid: boolean = false;
    invalidTime: boolean = false;
    radio: {
        emergencyChange: boolean;
        requiresInterruption: boolean;
        hasOrderNumber: boolean;
    } = {
        emergencyChange: false,
        requiresInterruption: false,
        hasOrderNumber: false,
    };
    generalInformation: FORM_INTERFACE.generalInformationInterface = {
        accessReasons: Array(),
        headquarters: 0,
        accessMotivesDataCenter: Array(),
        accessMotivesJob: Array(),
        accessMotivesChange: Array(),
        otherMotiveDataCenter: '',
        otherMotiveJob: '',
        otherMotiveChange: '',
        emergencyChangeReason: '',
        requiresInterruption: false,
        orderNumber: '',
        fromDateVal: '',
        fromTimeVal: '',
        toDateVal: '',
        toTimeVal: '',
        additionalComment: '',
    };

    fromDateFormatted: string = '';
    fromDateMenu: boolean = false;

    toDateFormatted: string = '';
    toDateMenu: boolean = false;

    rules: any = rules;

    $refs!: {
        form: any;
    };

    sendData() {
        this.generalInformation.requiresInterruption = this.radio.requiresInterruption;
        return { generalInformation: this.generalInformation };
    }

    dateInputted(date: string, type: string) {
        switch (type) {
            case 'from':
                this.fromDateMenu = false;
                this.fromDateFormatted = setLongFormatDate(date);
                this.generalInformation.fromTimeVal = '';
                this.generalInformation.toDateVal = '';
                this.toDateFormatted = '';
                this.generalInformation.toTimeVal = '';
                break;
            case 'to':
                this.toDateMenu = false;
                this.toDateFormatted = setLongFormatDate(date);
                this.generalInformation.toTimeVal = '';
                break;

            default:
                break;
        }
    }

    removeWeekends(date: string) {
        return !this.isWeekend(date);
    }

    isWeekend(date: string) {
        let weekend = [5, 6];
        // check if a given date's day of the week matches any in the array (5 and 6 being Sat and Sun)
        if (weekend.some(w => new Date(date).getDay() == w)) {
            //return true; no sabemos si se permiten los fines de semana, por ahora, se permitiran
            return false;
        }
        return false;
    }

    isAnEmergency() {
        return this.radio.emergencyChange;
    }

    minDate(type: string, interval: number) {
        let minDate;
        let currentDate = new Date();

        if (type === 'from') {
            if (this.isAnEmergency()) {
                minDate = moment().toISOString(true);
            } else {
                minDate = moment()
                    .add(interval, 'days')
                    .toISOString(true);
            }
        } else {
            minDate = moment(this.generalInformation.fromDateVal).toISOString(true);
        }

        return minDate;
    }

    maxDate(type: string, interval: number = 3) {
        let maxDate: string | undefined = undefined;
        let maxTime: string = '';

        if (type === 'to') {
            if (this.generalInformation.fromTimeVal && this.generalInformation.fromTimeVal !== '') {
                maxTime = ' ' + this.generalInformation.fromTimeVal;
            }

            maxDate = moment(this.generalInformation.fromDateVal + maxTime)
                .add(interval, 'days')
                .toISOString(true);
        }

        return maxDate;
    }

    restoreOrderNumber() {
        this.generalInformation.orderNumber = '';
    }

    restoreDateValue() {
        this.generalInformation.emergencyChangeReason = '';
        this.generalInformation.fromDateVal = '';
        this.generalInformation.fromTimeVal = '';
        this.fromDateFormatted = '';
        this.generalInformation.toDateVal = '';
        this.generalInformation.toTimeVal = '';
        this.toDateFormatted = '';
    }

    get requiresOtherMotiveAccess() {
        if (this.generalInformation.accessMotivesDataCenter.some(motive => motive == 20)) {
            return true;
        } else {
            this.generalInformation.otherMotiveDataCenter = '';
            return false;
        }
    }

    get requiresOtherMotiveJob() {
        if (this.generalInformation.accessMotivesJob.some(motive => motive == 20)) {
            return true;
        } else {
            this.generalInformation.otherMotiveJob = '';
            return false;
        }
    }

    get requiresOtherMotiveChange() {
        if (this.generalInformation.accessMotivesChange.some(motive => motive == 20)) {
            return true;
        } else {
            this.generalInformation.otherMotiveChange = '';
            return false;
        }
    }

    @Watch('generalInformation.accessReasons')
    resetMotives(values: number[], oldValues: number[]) {
        let removedReasons = oldValues.filter(oldValue => values.indexOf(oldValue) == -1);
        removedReasons.forEach(reason => {
            switch (reason) {
                case 1:
                    this.generalInformation.accessMotivesDataCenter = Array();
                    break;
                case 2:
                    this.generalInformation.accessMotivesJob = Array();
                    break;
                case 3:
                    this.generalInformation.accessMotivesChange = Array();
                    break;
                default:
                    break;
            }
        });
    }

    @Watch('generalInformation.accessMotivesDataCenter')
    @Watch('generalInformation.accessMotivesJob')
    @Watch('generalInformation.accessMotivesChange')
    emitMotives(value: number[], oldValue: number[]) {
        let unionMotives = [
            ...new Set([
                ...this.generalInformation.accessMotivesDataCenter,
                ...this.generalInformation.accessMotivesJob,
                ...this.generalInformation.accessMotivesChange,
            ]),
        ];
        this.$emit('accessMotives', unionMotives);
    }

    @Watch('oldGeneralInformation')
    assignOldValues(value: string, oldValue: string) {
        this.generalInformation = { ...this.oldGeneralInformation };
        this.fromDateFormatted = setLongFormatDate(this.generalInformation.fromDateVal);
        this.toDateFormatted = setLongFormatDate(this.generalInformation.toDateVal);
        if (!stringIsUndefined(this.oldGeneralInformation.emergencyChangeReason)) {
            this.radio.emergencyChange = true;
        }
        if (this.oldGeneralInformation.requiresInterruption) {
            this.radio.requiresInterruption = true;
        }
        if (!stringIsUndefined(this.oldGeneralInformation.orderNumber)) {
            this.radio.hasOrderNumber = true;
        }
    }

    validateStep() {
        if (this.$refs.form.validate()) {
            this.isFormValid = true;
            if (this.checkTime()) {
                this.$emit('nextStep');
                this.invalidTime = false;
            } else {
                this.setInvalidTimeError();
            }
        }
    }

    checkTime() {
        let validTime = rules.validTime(this.generalInformation.fromDateVal);
        if (validTime(this.generalInformation.fromTimeVal) === true) {
            return true;
        } else {
            return false;
        }
    }

    setInvalidTimeError() {
        this.invalidTime = true;
    }

    motivesFilter(accessReason: number) {
        let motives = Array();
        this.formValues.reasons.forEach(reason => {
            if (reason.value == accessReason) {
                motives = reason.motives;
            }
        });
        return motives;
    }

    checkReasons(reason: number) {
        return this.generalInformation.accessReasons.some(accessReason => accessReason == reason)
            ? true
            : false;
    }
}
